 const NFTLIST = [{
        id: 1,
        picUrl: `https://static.ibox.art/file/oss/test/image/nft-goods/33fb4232bc704532b0480753c0c84012.png?style=st6`,
        name: `Ms文创系列`,
        price: 21788
    },
    {
        id: 2,
        picUrl: `https://static.ibox.art/file/oss/test/image/nft-goods/458c3956565a4315bd03d647a7e61d0a.png?style=st6`,
        name: `大闹天宫系列`,
        price: 31887
    },
    {
        id: 3,
        picUrl: `https://static.ibox.art/file/oss/test/image/nft-goods/10e054e1d17144a4a4be3a50e2bad762.png?style=st6`,
        name: `深海公主`,
        price: 14999
    },
    {
        id: 4,
        picUrl: `https://static.ibox.art/file/oss/test/image/nft-goods/a7ba0679112b415fa9454c623f691548.png?style=st6`,
        name: `美探虎行星系列`,
        price: 299
    },
    {
        id: 5,
        picUrl: `https://static.ibox.art/file/oss/test/image/nft-goods/33fb4232bc704532b0480753c0c84012.png?style=st6`,
        name: `Ms文创系列`,
        price: 21788
    },
    {
        id: 6,
        picUrl: `https://static.ibox.art/file/oss/test/image/nft-goods/458c3956565a4315bd03d647a7e61d0a.png?style=st6`,
        name: `大闹天宫系列`,
        price: 31887
    }
];
export {
    NFTLIST
}